@if (loading()) {
  <div class="skeleton-rows">
    <ngx-skeleton-loader
      animation="progress"
      [theme]="{ height: '64px', borderRadius: '10px', marginBottom: '10px' }"
      count="3"
      appearance="line"></ngx-skeleton-loader>
  </div>
} @else {
  <app-nnn-registration-row-table
    [patientId]="patientId()"
    [registrations]="registrations()"
    [nandaIndex]="nandaIndex()"
    [nocIndex]="nocIndex()"
    [nicIndex]="nicIndex()"
    [appFunctionGroups]="appFunctionGroups()"
    [state]="finalState"
    [expandAllOnLoad]="true"></app-nnn-registration-row-table>
}
